import { useState } from 'react';
import PropTypes from 'prop-types';

import { Tooltip, IconButton, Button } from '@material-ui/core';
import InfoOutlineIcon from '@mui/icons-material/InfoOutlined';

PreviewButtonComponent.propTypes = {
  type: PropTypes.string,
  variant: PropTypes.string,
  color: PropTypes.string,
  tooltipTitle: PropTypes.string,
  ModalComponent: PropTypes.elementType,
  modalProps: PropTypes.object,
  buttonText: PropTypes.string
};

PreviewButtonComponent.defaultProps = {
  type: 'text',
  variant: 'contained',
  color: 'primary',
  tooltipTitle: 'Preview Data',
  modalProps: {},
  buttonText: 'Preview'
};

export default function PreviewButtonComponent({
  type,
  variant,
  color,
  tooltipTitle,
  ModalComponent,
  modalProps,
  buttonText
}) {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenModal = () => {
    setIsOpen(true);
  };
  return (
    <>
      {ModalComponent && <ModalComponent isOpen={isOpen} setIsOpen={setIsOpen} {...modalProps} />}
      {type === 'icononly' && (
        <Tooltip title={tooltipTitle} placement="top">
          <IconButton
            variant={variant}
            onClick={(e) => {
              e.stopPropagation();
              handleOpenModal();
            }}
            color={color}
            data-testid="generic-preview-button"
          >
            <InfoOutlineIcon />
          </IconButton>
        </Tooltip>
      )}
      {type === 'text' && (
        <Tooltip title={tooltipTitle} placement="top">
          <Button
            data-testid="generic-preview-button"
            startIcon={<InfoOutlineIcon />}
            color={color}
            variant={variant}
            onClick={(e) => {
              e.stopPropagation();
              handleOpenModal();
            }}
          >
            {buttonText}
          </Button>
        </Tooltip>
      )}
    </>
  );
}
